import { getCredentialList } from './states';

export const services = {
  getCredentialList,
};
